export class HomeSlickComponent {
    protected _currentContext: JQuery = $();

    protected _countView: JQuery = $();
    protected _currentNumber: JQuery = $();
    protected _totalAmount: JQuery = $();

    protected moduleOptions: JQuerySlickOptions = {
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    private _classMap = {
        currentNumber: ".js-current-number",
        totalAmount: ".js-all-number"
    };

    private _window: JQuery<Window> = $(window);

    public getSlick(): JQuerySlick {
        return this._currentContext.slick("getSlick");
    }

    public refresh(): void {
        this._currentContext.slick("refresh");
    }

    public destroy(): void {
        this._currentContext.slick("unslick");
    }

    public isInitialized(): boolean {
        return this._currentContext.hasClass("slick-initialized");
    }

    protected bindEvents(): void {
        this._window.on("orientationchange resize", () => {
            if (!this.isInitialized()) {
                this._currentContext.slick(this.moduleOptions);
            } else {
                this._currentContext.slick("resize");
            }
        });
    }

    public init(context: JQuery, options: JQuerySlickOptions): void {
        this._currentContext = context || this._currentContext;
        this.moduleOptions = $.extend({}, options);

        this._currentContext.slick(this.moduleOptions);

        this.bindEvents();
    }

    public static init(context: JQuery, options: JQuerySlickOptions): HomeSlickComponent {
        const slider = new HomeSlickComponent();
        slider.init(context, options);
        return slider;
    }
}
